<template>
	<el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :before-close="handleClose" append-to-body>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="学校" prop="schoolId" v-show="getUserInfo.roleID==1">
				<el-select placeholder="请选择学校" v-model="ruleForm.schoolId" class="w-100"
					@change="ruleForm.deptId='';ruleForm.majorId=''">
					<el-option :label="item.name" :value="item.id" v-for="item in getSchoolArray"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="学院" prop="deptId" v-show="getUserInfo.roleID<=2">
				<el-select placeholder="请选择学院" v-model="ruleForm.deptId" class="w-100" @change="ruleForm.majorId=''">
					<el-option :label="item.name" :value="item.id" v-for="item in showDept()"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="专业" prop="majorId" >
				<el-select placeholder="请选择专业" v-model="ruleForm.majorId" class="w-100">
					<el-option :label="item.name" :value="item.id" v-for="item in showMajor()"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="班级名称" prop="name">
				<el-input v-model="ruleForm.name" @input="inputName()"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="submitForm('ruleForm')">立即{{type==='add'?'添加':'修改'}}</el-button>
			<el-button @click="resetForm('ruleForm')">重置</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import pinyin from '../../../../public/js/Convert_Pinyin.js'

	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'classEdit',
		props: {
			type: {
				type: String,
				default: 'add'
			},
			title: {
				type: String
			},
			dialogVisible: {
				type: Boolean,
				default: false
			},
			obj: {
				type: Object,
				default: null
			},
			getSchoolArray: {
				type: Array,
				default: null
			},
			getDeptArray: {
				type: Array,
				default: null
			},
			getMajorArray: {
				type: Array,
				default: null
			},
			getClassArrayName: {
				type: Array,
				default: null
			}
		},
		data() {
			return {
				ruleForm: {
					id: '',
					name: '',
					schoolId: '',
					deptId: '',
					majorId: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入班级名称',
						trigger: 'blur'
					}],
					schoolId: [{
						required: true,
						message: '请选择学校',
						trigger: 'change'
					}],
					deptId: [{
						required: true,
						message: '请选择学院',
						trigger: 'change'
					}],
					majorId: [{
						required: true,
						message: '请选择专业',
						trigger: 'change'
					}]
				}
			}
		},
		watch: {
			obj(val) {
				this.ruleForm = JSON.parse(JSON.stringify(val))
			}
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		methods: {
			inputName() {
				let e = pinyin.getFullChars(this.ruleForm.name).match(/[A-Z]/g)
				if (e != null)
					this.ruleForm.firstLetter = e.join('')
				else
					this.ruleForm.firstLetter = ''
			},
			refreshCode() {
				this.ruleForm.authCode = (Math.random() * 1e17).toString(36).substring(0, 10).toUpperCase()
			},
			submitForm(formName) { 
				this.$refs[formName].validate((valid) => {
					if (valid) {

						if (this.type === 'add' && this.getClassArrayName.findIndex(item =>
								item.majorId === this.ruleForm.majorId &&
								item.name === this.ruleForm.name) > -1) {
							this.$alert('已有重复的班级', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									return false
								}
							})
							return false
						}
						if (this.type === 'update' && this.getClassArrayName.findIndex(item =>
								item.majorId === this.ruleForm.majorId &&
								item.name === this.ruleForm.name &&
								this.obj.name != this.ruleForm.name) > -1) {
							this.$alert('已有重复的班级', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									return false
								}
							})
							return false
						}
						this.type === 'add' && this.$http.post('api/Org/SaveClass', this.ruleForm).then(res => {
							this.handleClose()
						})
						this.type === 'update' && this.$http.post('api/Org/EditClass', this.ruleForm).then(res => {
							this.handleClose()
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleClose() {
				this.$emit('before-close')
			},
			showDept() {
				return this.getDeptArray.filter(item => item.schoolId.search(this.ruleForm.schoolId) > -1)
			},
			showMajor() {
				return this.getMajorArray.filter(item => item.deptId.search(this.ruleForm.deptId) > -1)
			}
		},
		mounted() {
			if (this.getUserInfo.roleID >= 2) {
				this.ruleForm.schoolId = this.getUserInfo.schoolID
			}
			
			if(this.getUserInfo.roleID >= 3) {
				this.ruleForm.deptId = this.getUserInfo.deptID
			}
		}
	}
</script>

<style>
</style>
